import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";
import { useNavigate } from "react-router";

import { ApiError } from "@shared/types";
import { Company } from "@modules/companies/types";
import { CompanyFormValues } from "@modules/companies/validations";

import { createCompanyService } from "./service";
import { UseCreateCompanyMutationOptions } from "./types";
import { listCompaniesQueryKey } from "../../queries/listCompanies/query";

export function useCreateCompanyMutation(
  options?: UseCreateCompanyMutationOptions
) {
  const translate = useTranslate();
  const navigate = useNavigate();
  const { open } = useNotification();
  const queryClient = useQueryClient();

  return useMutation<Company, ApiError, CompanyFormValues>({
    mutationFn: createCompanyService,
    onSuccess: (company: Company) => {
      queryClient.invalidateQueries({
        queryKey: listCompaniesQueryKey,
        refetchType: "all",
      });

      open?.({
        type: "success",
        message: translate("v1/company_admin.success.create"),
      });

      navigate(`/companies/edit/${company.id}`);
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
